import { render } from "./ProjectsListContainer.vue?vue&type=template&id=fe1518fc&scoped=true"
import script from "./ProjectsListContainer.vue?vue&type=script&lang=js"
export * from "./ProjectsListContainer.vue?vue&type=script&lang=js"

import "./ProjectsListContainer.vue?vue&type=style&index=0&id=fe1518fc&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe1518fc"]])

export default __exports__